import './treatment.scss';

export default () => {
};
